<template>
  <div :class="$style.errorText">
    <p v-if="apiDisabled">
      Your {{ platformDisplayName }} account does not have API access enabled.
      <span v-if="isGSuite">
        Please go
        <a
          :href="gsuiteAdminUrl"
          rel="noopener noreferrer"
          target="_blank"
        >
          here
        </a>
      </span>
      to enable it.
    </p>
    <p v-else-if="invalidToken">
      Your {{ platformDisplayName }} authorization token is no longer valid.
      Please reactivate sync.
    </p>
    <p v-else-if="forbidden">
      Your {{ platformDisplayName }} authorization token does not have
      permissions to manage users. Please ensure you are logged into {{ platformDisplayName }} with
      an administrator who has permission to manage users and reactivate sync.
    </p>
    <p v-else>
      There was an error fetching users from {{ platformDisplayName }}.
    </p>
  </div>
</template>

<script>
import {
  DirectoryNameConsts,
  DirectoryTypeConsts,
  ExportFileTypes,
} from 'client/util/Constants';

export default {
  name: 'ImportError',
  props: {
    error: {
      type: String,
      required: true,
    },
    importType: {
      type: String,
      default: 'platform',
    },
  },
  data() {
    return {
      apiDisabledError: 'domainCannotUseApis',
      forbiddenError: 'forbidden',
      gsuiteAdminUrl: 'https://admin.google.com/AdminHome#SecuritySettings:flyout=apimanagement',
      invalidTokenError: 'oauth2: cannot fetch token',
    };
  },
  computed: {
    apiDisabled() {
      return this.error.includes(this.apiDisabledError);
    },
    forbidden() {
      return this.error.includes(this.forbiddenError);
    },
    invalidToken() {
      return this.error.includes(this.invalidTokenError);
    },
    isGSuite() {
      return this.importType === 'gsuite';
    },
    platformDisplayName() {
      let name = 'platform';

      if (this.importType === ExportFileTypes.csv) {
        name = 'CSV import';
      }

      if (this.importType.includes('scim')) {
        name = 'SCIM application';
      }

      if (this.isGSuite) {
        name = DirectoryNameConsts[DirectoryTypeConsts.gSuite];
      }

      if (this.importType === 'office365') {
        name = DirectoryNameConsts[DirectoryTypeConsts.office365];
      }

      return name;
    },
  },
};
</script>

<style module>
.errorText {
  margin: 0 100px;
  text-align: center;
}
</style>
